import { cloneDeep } from "lodash";

const ObjectsHelper = {
  updateProperties(object: any, properties: any): any {
    Object.keys(properties).forEach((key: string) => {
      object[key] = properties[key];
    });

    return object;
  },
};

export default ObjectsHelper;
